import { Box, CircularProgress, Fade, Skeleton } from '@mui/material';
import React from 'react';

// import clock from '../../Loader/loading-chart.gif';
import NoData from '../NoData';

/* eslint-disable react/display-name */
const ProgressiveChart = Component => props => {
  return (
    props.chart && props.chart.noData ?
      <NoData noData={true} wrapperClass={`chart-no-data ${props.noDataClass || ''}`} />
      :
      (props.showChart ?
        <Component {...props} />
        :
        <Box
          className={`chart-loader ${props.cssClass || ''}`}
          sx={{ position: 'relative' }}
        >
          <Fade
            in={!(props.showChart)}
            style={{
              transitionDelay: !(props.showChart) ? '800ms' : '0ms',
            }}
            unmountOnExit
          >
            <Skeleton animation="wave" variant="rounded" width="100%" height={200} style={{ marginBottom: 6 }} />
            {/* <CircularProgress
              color="inherit"
              sx={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)'
              }}
            /> */}
          </Fade>
        </Box>
      )
  )
}

export default ProgressiveChart;
